import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import MyVoucher from "../../components/User/MyVoucher";

export default withRouter(connect()(MyVoucher));
